const status = {
  NOT_CONNECTED: 'not_connected',
  PRIOR_DATA_PRESENT: 'prior_data_present',
  ACCUMULATION_DATA_PRESENT: 'accumulation_data_present',
};

module.exports = {
  status,
};
